<template>
  <stihl-multiselect
    :model-value="selected"
    @update:model-value="$emit('update:model-value', $event)"
    :options-provider="optionsProvider"
    :selection-format-supplier="selectionFormatSupplier"
    :is-item-read-only="isItemReadOnly"
    :placeholder="$t('adm.page.users.orgMultiselectPlaceholder')"
    id-attribute="id"
    label-attribute="displayName"
    :search="searchOrg"
    :disabled="disabled">
    <template #found="{ item }">
      <span class="stihl-ms-item-text stihl-ms-item-add">
        <span class="link">{{ item.displayName }}
          <stihl-icon icon="status-error" v-tooltip="$t('adm.label.inactiveOrg')" v-if="item.isInactive" />
        </span>
      </span>
    </template>
    <template #option="{ item }">
      <span class="stihl-ms-item-text">
        <span class="link">{{ item.displayName }}
          <stihl-icon icon="status-error" v-tooltip="$t('adm.label.inactiveOrg')" v-if="item.isInactive" />
        </span>
      </span>
    </template>
  </stihl-multiselect>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { DisplayableOrg } from '@/components/utils';
import Backend, { OrganizationData } from '@/components/backend';
import StihlIcon from '@/components/ui/StihlIcon.vue';
import StihlMultiselect from '@/components/ui/StihlMultiselect.vue';

// query selection
const $select = 'id,name,crmNo,state';

export const toDisplayable = (org?: OrganizationData[]): DisplayableOrg[] => (
  org?.map((x: OrganizationData) => new DisplayableOrg(x)) ?? []
);

export default defineComponent({
  name: 'SelectMultiOrganizations',
  components: { StihlMultiselect, StihlIcon },
  emits: ['update:model-value'],
  props: {
    selected: { type: Array as PropType<string[]>, default: new Array<string>() },
    disabled: { type: Boolean, default: false },
    optionsProvider: { type: Function as PropType<() => Promise<DisplayableOrg[]>>, default: null },
    selectionFormatSupplier: { type: Function as PropType<(itemsNo: number) => string>, default: null },
    isItemReadOnly: { type: Function as PropType<(key: string) => boolean>, default: () => false },
  },
  methods: {

    async searchOrg(filter?: string): Promise<DisplayableOrg[]> {
      // Logger.info('select-multi-org', `search org by filter:"${filter}"`);
      if (filter) {
        const api = await Backend.validateToken();
        return api.findOrganizations({ $search: filter, $select })
          .then((r) => toDisplayable(r.data));
      }
      return [];
    },
  },
});
</script>
